import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export function useDeleteConversation() {
  const queryClient = useQueryClient();

  const {
    mutate,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`conversations/${id}`),
    onError: deleteError =>
      notifyAndLogError(
        'Could not delete chat',
        'The chat could not be deleted. Please try again.',
        deleteError,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });

  const deleteConversation = (id: string) => mutate(id);

  return { deleteConversation, error, isLoading, reset };
}
